import React, {useState} from "react";
import fire from "./fire";

const Hero = ({handleLogout}) => {
const [progress, setProgress] = useState(0);
const formHandler = (e) => {
    e.preventDefault();
    const file = e.target[0].files[0];
    uploadFiles(file);
};
const uploadFiles = (file)=>{
   const uploadTask = fire.ref(`/files/${file.name}`).put(file);
   uploadTask.on("state_changed",(snapshot)=>{
const progress = Math.round((snapshot.byteTransferred / snapshot.totalbytes) * 100
);
setProgress(progress);
   },
   (error) => console.log(error),
   () => {
       fire
       .ref("files")
       .child(file.name)
       .getDownloadURL()
       .then((url) => {
           console.log(url);
       });
   }
   )
}
    
     
    return(
        <section className="hero">
            <nav>
                <h2>Admin Panel</h2>
                <ul><a href='https://console.firebase.google.com/project/wave-admin-panel/storage/wave-admin-panel.appspot.com/files'><button>Console</button></a>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button onClick={handleLogout}>Logout</button></ul>
                
            </nav>
            
               <div className="hero">
                   <form onSubmit={formHandler}>
                       <input type="file" />
                       <button type="submit">Upload</button>
                   </form>
                   <hr />
                   <h2 className="hero">Uploading done {progress}%</h2>
               </div>
                
        
        </section>
    )
}

export default Hero;